import { Alert, Button, Typography } from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";

interface Props {
  showWarning: boolean;
  onApplyDefaults: () => void;
}

export const ScrapChefDefaultsWarning = ({
  showWarning,
  onApplyDefaults,
}: Props) => {
  const { t } = useTenantTranslation();

  if (!showWarning) {
    return null;
  }

  return (
    <Alert
      severity="info"
      sx={{
        "& .MuiAlert-action": {
          pt: "2px",
        },
      }}
      action={
        <Button onClick={onApplyDefaults} color="secondary">
          {t("useScrapChefDefaults")}
        </Button>
      }
    >
      <Typography variant="body1">{t("scrapchefDefaultsWarning")}</Typography>
    </Alert>
  );
};
